<template>
  <transition name="popup-fade">
    <div v-if="isVisible" class="popup-overlay" @click.self="closePopup">
      <div class="popup-scroll-container">
        <div class="popup-container">
          <!-- Close button -->
          <button class="popup-close" @click="closePopup">✕</button>

          <!-- Header -->
          <div class="popup-header">
            <div class="popup-icon">🎁</div>
            <h2 class="popup-title">Добро пожаловать!</h2>
            <p class="popup-subtitle">Подарок для новых пользователей</p>
          </div>

          <!-- Promo Code Section -->
          <div class="promo-section">
            <div class="promo-label">Ваш промокод</div>
            <div class="promo-code-container">
              <div class="promo-code">3DAY3</div>
              <button class="copy-btn" @click="copyPromoCode">
                {{ copied ? '✓' : '📋' }}
              </button>
            </div>
            <div class="promo-description">
              <span class="promo-icon">⭐</span>
              <strong>3 дня Basic тарифа</strong> бесплатно
            </div>
            <div class="promo-activation-hint" @click="goToReferrals">
              💡 Активируй во вкладке <strong>Рефералы</strong>
            </div>
          </div>

          <!-- Tasks Section -->
          <div class="tasks-section">
            <div class="tasks-header">
              <div class="tasks-icon-large">✨</div>
              <div class="tasks-text">
                <div class="tasks-title">Выполняй задания</div>
                <div class="tasks-subtitle">Получай бесплатные дни подписки</div>
              </div>
            </div>
            <div class="tasks-benefits">
              <div class="benefit-item">
                <span class="benefit-icon">📢</span>
                <span>Подпишись на канал — <strong>+2 дня</strong></span>
              </div>
              <div class="benefit-item">
                <span class="benefit-icon">🎯</span>
                <span>Новые задания появятся скоро</span>
              </div>
            </div>
            <button class="tasks-btn-large" @click="openTasks">
              Перейти к заданиям
            </button>
          </div>

          <!-- Start Button -->
          <button class="start-btn" @click="closePopup">
            <span class="btn-content">Начать пользоваться</span>
            <span class="btn-shine"></span>
          </button>

        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { haptic } from '@/utils/telegram';

const router = useRouter();

const props = defineProps({
  isVisible: {
    type: Boolean,
    required: true
  }
});

const emit = defineEmits(['close', 'openTasks']);

const copied = ref(false);

const copyPromoCode = () => {
  haptic.impact();

  const promoCode = '3DAY3';

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(promoCode)
      .then(() => {
        copied.value = true;
        setTimeout(() => {
          copied.value = false;
        }, 2000);
      })
      .catch(err => {
        console.error('Ошибка копирования:', err);
      });
  } else {
    const textArea = document.createElement('textarea');
    textArea.value = promoCode;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      copied.value = true;
      setTimeout(() => {
        copied.value = false;
      }, 2000);
    } catch (err) {
      console.error('Ошибка копирования:', err);
    }
    document.body.removeChild(textArea);
  }
};

const openTasks = () => {
  haptic.impact();
  emit('openTasks');
};

const goToReferrals = () => {
  haptic.impact();
  router.push('/referal');
  emit('close');
};

const closePopup = () => {
  haptic.impact();
  emit('close');
};

// Блокировка скролла body при открытии попапа
onMounted(() => {
  if (props.isVisible) {
    document.body.style.overflow = 'hidden';
  }
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 0;
  overflow: hidden;
}

/* Новый контейнер для скролла */
.popup-scroll-container {
  width: 100%;
  max-width: 440px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  /* КРИТИЧНО: отступ сверху для Telegram кнопок */
  padding-top: 80px;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.popup-container {
  background: rgba(26, 31, 41, 0.95);
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 24px;
  padding: 28px 24px 24px 24px;
  width: 100%;
  max-width: 90%; /* Ограничение ширины */
  position: relative;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.5),
    0 0 0 0.5px rgba(255, 255, 255, 0.1) inset;
  margin: 0 auto 140px auto;
  min-height: min-content;
  flex-shrink: 0;
}

/* Для устройств с вырезом (notch) */
@supports (padding: max(0px)) {
  .popup-scroll-container {
    padding-top: max(80px, calc(env(safe-area-inset-top) + 60px));
    padding-left: max(20px, env(safe-area-inset-left));
    padding-right: max(20px, env(safe-area-inset-right));
    padding-bottom: max(20px, env(safe-area-inset-bottom));
  }
}

/* Дополнительные отступы для мобильных устройств */
@media (max-width: 768px) {
  .popup-scroll-container {
    padding-top: max(80px, calc(env(safe-area-inset-top, 0px) + 60px));
  }

  .popup-container {
    margin-bottom: 160px;
  }
}

/* Для устройств с малой высотой экрана */
@media (max-height: 700px) {
  .popup-scroll-container {
    padding-top: 70px;
  }

  .popup-container {
    margin-bottom: 140px;
    padding: 24px 20px 20px 20px;
  }

  .popup-icon {
    font-size: 52px !important;
    margin-bottom: 8px !important;
  }

  .popup-title {
    font-size: 22px !important;
  }
}

/* Для очень маленьких экранов по высоте */
@media (max-height: 600px) {
  .popup-scroll-container {
    padding-top: 60px;
  }

  .popup-container {
    padding: 20px 18px 18px 18px;
  }

  .popup-header {
    margin-bottom: 16px !important;
  }

  .promo-section,
  .tasks-section {
    padding: 16px !important;
    margin-bottom: 16px !important;
  }
}

/* Для больших экранов (десктоп) */
@media (min-width: 769px) {
  .popup-scroll-container {
    align-items: center;
    padding-top: 20px;
  }

  .popup-container {
    margin-bottom: 20px;
  }
}

/* Специально для Telegram WebApp в полноэкранном режиме */
@media (display-mode: fullscreen) {
  .popup-scroll-container {
    padding-top: 90px;
  }
}

/* Для iPhone с Dynamic Island */
@media (max-width: 430px) and (min-height: 800px) {
  .popup-scroll-container {
    padding-top: max(90px, calc(env(safe-area-inset-top) + 70px));
  }
}

.popup-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.popup-close:active {
  transform: scale(0.9);
  background: rgba(255, 255, 255, 0.2);
}

.popup-header {
  text-align: center;
  margin-bottom: 24px;
}

.popup-icon {
  font-size: 64px;
  margin-bottom: 12px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.popup-title {
  font-size: 26px;
  font-weight: 800;
  margin-bottom: 8px;
  background: linear-gradient(135deg, #FF6B35, #F7931E);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.popup-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.4;
}

.promo-section {
  background: rgba(255, 107, 53, 0.15);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 107, 53, 0.3);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(255, 107, 53, 0.2);
}

.promo-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 8px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.promo-code-container {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.promo-code {
  flex: 1;
  background: rgba(26, 31, 41, 0.8);
  border: 2px dashed rgba(255, 107, 53, 0.5);
  border-radius: 12px;
  padding: 16px;
  font-size: 24px;
  font-weight: 800;
  text-align: center;
  letter-spacing: 2px;
  color: #FF8555;
  font-family: 'Courier New', monospace;
}

.copy-btn {
  width: 48px;
  height: 48px;
  background: rgba(255, 107, 53, 0.2);
  border: 1px solid rgba(255, 107, 53, 0.4);
  border-radius: 12px;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.copy-btn:active {
  transform: scale(0.9);
  background: rgba(255, 107, 53, 0.3);
}

.promo-description {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.4;
}

.promo-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.tasks-section {
  background: rgba(117, 216, 185, 0.15);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(117, 216, 185, 0.3);
  border-radius: 16px;
  padding: 18px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(117, 216, 185, 0.2);
}

.promo-activation-hint {
  margin-top: 12px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  line-height: 1.4;
  cursor: pointer;
  transition: all 0.2s;
}

.promo-activation-hint:active {
  transform: scale(0.97);
  background: rgba(255, 255, 255, 0.08);
}

.promo-activation-hint strong {
  color: #FF8555;
  font-weight: 700;
}

.tasks-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.tasks-icon-large {
  font-size: 36px;
  flex-shrink: 0;
  line-height: 1;
}

.tasks-text {
  flex: 1;
}

.tasks-title {
  font-size: 17px;
  font-weight: 700;
  color: #75d8b9;
  margin-bottom: 3px;
  line-height: 1.2;
}

.tasks-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.3;
}

.tasks-benefits {
  margin-bottom: 14px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 8px;
  line-height: 1.3;
}

.benefit-item:last-child {
  margin-bottom: 0;
}

.benefit-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.tasks-btn-large {
  background: rgba(117, 216, 185, 0.25);
  border: 1px solid rgba(117, 216, 185, 0.4);
  color: #75d8b9;
  padding: 13px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s;
}

.tasks-btn-large:active {
  transform: scale(0.97);
  background: rgba(117, 216, 185, 0.35);
}

.start-btn {
  position: relative;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  color: white;
  padding: 16px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.18);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 1px 0 rgba(255, 255, 255, 0.2) inset,
    0 -1px 0 rgba(0, 0, 0, 0.2) inset;
  overflow: hidden;
}

.btn-content {
  position: relative;
  z-index: 2;
  display: block;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.btn-shine {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    135deg,
    transparent 0%,
    rgba(255, 255, 255, 0.15) 45%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0.15) 55%,
    transparent 100%
  );
  transform: translateX(-100%) translateY(-100%) rotate(45deg);
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}

.start-btn:hover .btn-shine {
  transform: translateX(0) translateY(0) rotate(45deg);
}

.start-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.4),
    0 1px 0 rgba(255, 255, 255, 0.25) inset,
    0 -1px 0 rgba(0, 0, 0, 0.2) inset;
  transform: translateY(-1px);
}

.start-btn:active {
  transform: scale(0.98) translateY(0);
  background: rgba(255, 255, 255, 0.06);
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.3),
    0 1px 0 rgba(255, 255, 255, 0.15) inset,
    0 -1px 0 rgba(0, 0, 0, 0.3) inset;
}

/* Transitions */
.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: opacity 0.3s ease;
}

.popup-fade-enter-active .popup-scroll-container,
.popup-fade-leave-active .popup-scroll-container {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.popup-fade-enter-from,
.popup-fade-leave-to {
  opacity: 0;
}

.popup-fade-enter-from .popup-scroll-container {
  transform: scale(0.9) translateY(20px);
}

.popup-fade-leave-to .popup-scroll-container {
  transform: scale(0.9) translateY(20px);
}

/* Scrollbar для popup-scroll-container */
.popup-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.popup-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.popup-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(255, 107, 53, 0.4);
  border-radius: 3px;
}

.popup-scroll-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 107, 53, 0.6);
}
</style>